import React, { useMemo } from "react";
import ReactSelector from "../../components/common/CommonReactSelector";
import translations from "../../components/common/Translations";

const FIELD_LABEL_CLASS = "text-[11.5px] font-semibold text-slate-500 dark:text-slate-300";
const FIELD_INPUT_CLASS =
  "bg-white border border-gray-300 text-gray-900 text-[13.5px] rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full h-[38px] px-3 dark:focus:ring-blue-500 dark:focus:border-blue-500";

const CloneOption = ({
  isClone,
  isEdit,
  langMode,
  theme,
  workflowName,
  maxAllowedAccuracy,// update by harshit
  handleMaxAllowedAccuracyChangee,// update by harshit
  title,
  handleChangee,
  titleHandle,
  handleTimer,
  selectedTimer,
  timerValue,
  Translations,
  isSafetyComplianceRequired,
  safetyWorkflowName,
  handleSafetyWorkflowNameChange,
}) => {
  const timerOptions = useMemo(() => {
    return (timerValue || []).map((val) => ({
      value: val,
      label: String(val),
    }));
  }, [timerValue]);

  const themeClass =
    theme === "dark" ? "dark-mode " : theme === "high-contrast" ? "high-contrast" : "";

  /** Edit and clone share the same top toolbar; keep vertical rhythm aligned (incl. RTL). */
  const fieldColClass = "flex flex-col gap-1.5 shrink-0";

  return (
    <div className="flex flex-col sm:flex-row flex-wrap items-start sm:items-end gap-y-3 sm:gap-y-0 gap-x-0 sm:gap-x-4 w-full">
      {isClone ? (
        <div className={`${fieldColClass} flex-1 min-w-[220px] max-w-[340px]`}>
          <div className="flex items-center min-h-[18px]">
            <label htmlFor="cloneName" className={FIELD_LABEL_CLASS}>
              {Translations[langMode].entername}
            </label>
            <span className="text-red-500 ms-1">*</span>
          </div>
          <input
            id="cloneName"
            type="text"
            value={workflowName}
            className={`${FIELD_INPUT_CLASS} ${themeClass}`}
            onChange={handleChangee}
            placeholder={Translations[langMode].enterWorkflowName}
          />
        </div>
      ) : isEdit ? (
        <div className={`${fieldColClass} flex-1 min-w-[220px] max-w-[340px]`}>
          <div className="flex items-center min-h-[18px]">
            <label htmlFor="cloneName" className={FIELD_LABEL_CLASS}>
              {Translations[langMode].entername}
            </label>
            <span className="text-red-500 ms-1">*</span>
          </div>
          <input
            id="cloneName"
            type="text"
            value={workflowName}
            className={`${FIELD_INPUT_CLASS} ${themeClass}`}
            onChange={handleChangee}
            placeholder={Translations[langMode].enterWorkflowName}
          />
        </div>
      ) : (
        <div className={`${fieldColClass} flex-1 min-w-[220px] max-w-[340px]`}>
          <div className="flex items-center min-h-[18px]">
            <label htmlFor="cloneName" className={FIELD_LABEL_CLASS}>
              {Translations[langMode].entername}
            </label>
            <span className="text-red-500 ms-1">*</span>
          </div>
          <input
            id="cloneName"
            type="text"
            value={workflowName}
            className={`${FIELD_INPUT_CLASS} ${themeClass}`}
            onChange={handleChangee}
            placeholder={Translations[langMode].enterWorkflowName}
          />
        </div>
      )}

      <div className={`${fieldColClass} flex-1 min-w-[220px] max-w-[340px]`}>
        <div className="flex items-center min-h-[18px]">
          <label htmlFor="pdfTitle" className={FIELD_LABEL_CLASS}>
            {Translations[langMode].title}
          </label>
          <span className="text-red-500 ms-1">*</span>
        </div>
        <input
          id="pdfTitle"
          type="text"
          value={title}
          className={`${FIELD_INPUT_CLASS} ${themeClass}`}
          onChange={titleHandle}
          placeholder={Translations[langMode].enterPDFTitle}
        />
      </div>

      {isSafetyComplianceRequired && (
        <div className={`${fieldColClass} flex-1 min-w-[220px] max-w-[340px]`}>
          <div className="flex items-center min-h-[18px]">
            <label htmlFor="safetyWorkflowName" className={FIELD_LABEL_CLASS}>
              {translations[langMode].safetyChecklistName ??
                "Safety Checklist Name"}
            </label>
            <span className="text-red-500 ms-1">*</span>
          </div>
          <input
            id="safetyWorkflowName"
            type="text"
            value={safetyWorkflowName}
            className={`${FIELD_INPUT_CLASS} ${themeClass}`}
            onChange={handleSafetyWorkflowNameChange}
            placeholder={
              translations[langMode].enterSafetyChecklistName ??
              "Enter a name for the safety checklist"
            }
          />
        </div>
      )}

      <div className={`${fieldColClass} w-28`}>
        <div className="flex items-start min-h-[18px]">
          <label htmlFor="numberDropdown" className={FIELD_LABEL_CLASS}>
            {Translations[langMode].selectTimer}
          </label>
        </div>
        <ReactSelector
          options={timerOptions}
          onChange={(selected) => handleTimer({ target: { value: selected?.value } })}
          value={timerOptions.find(opt => opt.value === selectedTimer)}
          isSearchable={false}
          isClearable={false}
          hideSearch
          height="38px"
          borderRadius="8px"
          fontSize="13.5px"
        />
      </div>

      <div className={`${fieldColClass} w-44`}>
        <div className="flex items-start min-h-[18px]">
          <label htmlFor="maxAllowedAccuracy" className={FIELD_LABEL_CLASS}>
            {Translations[langMode].maximumLocationAccuracy}
          </label>
        </div>
        <input
          id="maxAllowedAccuracy"
          type="number"
          value={maxAllowedAccuracy}
          className={`${FIELD_INPUT_CLASS} ${themeClass}`}
          onChange={handleMaxAllowedAccuracyChangee}
          placeholder={Translations[langMode].maximumLocationAccuracy}
        />
      </div>
    </div>
  );
};

export default CloneOption;
